import { useEffect, useState } from "react";
import { wpGet } from "../utils/api";

type WPBranding = {
  logo?: string;
  siteName?: string;
};

export default function useWPBranding() {
  const [branding, setBranding] = useState<WPBranding | null>(null);

  useEffect(() => {
    let active = true;

    const load = async () => {
      try {
        const data = await wpGet<WPBranding>("/multisite/v1/branding");
        if (active) setBranding(data);
      } catch {
        if (active) setBranding(null);
      }
    };

    load();
    return () => {
      active = false;
    };
  }, []);

  return branding;
}
